import React from "react";

import { type Repos, ReposContext } from "@/components/contexts/repos-context.ts";
import { DataSubmissionRepository } from "@/repositories/data-submission-repository.ts";
import { NewsRepository } from "@/repositories/news-repository.ts";
import { SessionRepository } from "@/repositories/session-repository.ts";
import { SiteSettingsRepository } from "@/repositories/site-settings-repository.ts";
import { UserRepository } from "@/repositories/user-repository.ts";
import AuthService from "@/services/auth-service.ts";
import SessionService from "@/services/session-service.ts";

export function ReposProvider({ children }: { children: React.ReactNode }) {
    const sessionRepo = SessionRepository.getInstance();
    const userRepo = UserRepository.getInstance();
    const newsRepo = NewsRepository.getInstance();
    const dataSubmissionRepo = DataSubmissionRepository.getInstance();
    const authService = AuthService.getInstance(userRepo, dataSubmissionRepo);
    const sessionService = SessionService.getInstance(sessionRepo);
    const settingsRepo = SiteSettingsRepository.getInstance();

    const repos: Repos = {
        sessionRepo: sessionRepo,
        userRepo: userRepo,
        newsRepo: newsRepo,
        dataSubmissionRepo: dataSubmissionRepo,
        authService: authService,
        sessionService: sessionService,
        settingsRepo: settingsRepo,
    };

    return <ReposContext.Provider value={repos}>{children}</ReposContext.Provider>;
}
